export { LocationModule } from './location.module';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+location/index.ts